module.exports = __webpack_public_path__ + "img/sensotex_tab.436f4b5.webp";